import _ from 'lodash';

export function createDebouncedFunction(func, delay = 500) {
    return _.debounce(func, delay);
}
